export enum USER_ACTIONS {
  SET = 'USER_SET',
  EDIT = 'USER_EDIT',
  LOGOUT = 'USER_LOGOUT',
  REGISTER = 'USER_REGISTER'
}
